import { IValue } from '@platform500services/p500-ui-kit';

const getStringValue = (valuePql: IValue[]): string => {
  const stringPqlValue = valuePql
    .filter((condition) => {
      if (!condition.operator) {
        return false;
      }
      const value = condition.value;
      switch (value) {
        case 0:
        case false:
          return true;
        default:
          if (value) {
            return true;
          }
          return false;
      }
    })
    .map((condition, index) => {
      const { config, key, operator, value } = condition;
      return index
        ? `${config} ${key} ${operator} ${getStringConditionValue(value)}`
        : `${key} ${operator} ${getStringConditionValue(value)}`;
    })
    .join(' ');
  return stringPqlValue;
};

const getStringConditionValue = (value: string[] | string): string => {
  return typeof value === 'string'
    ? `'${value}'`
    : Array.isArray(value)
    ? `[${value.map((element) => `'${element}'`).join(',')}]`
    : String(value);
};

const mentionSelect = (item: any) => {
  return ' ' + item.label;
};

const mentionConfig = (keys: string[]) => ({
  mentions: [
    {
      items: keys,
      triggerChar: '@',
      mentionSelect,
      disableSort: true,
    },
    {
      items: ['AND', 'OR', '=', '!=', '>', '<', '>=', '<=', 'IN', 'NOT_IN', 'LIKE', 'NOT LIKE'],
      triggerChar: '#',
      mentionSelect,
      disableSort: true,
    },
  ],
});

const parseValue = (value: string, i: number): string => {
  if (!(i && !(i % 2) && i % 4)) {
    return value;
  }
  try {
    return JSON.parse(value.replace(/'/g, '"'));
  } catch {
    return value;
  }
};

const getParsedPql = (value: string | undefined): IValue[] => {
  if (!value) return [];
  const split = getParsePql(value).map(parseValue);
  const result: IValue[] = [getFirstValue(split)];
  let i = 4;
  while (i <= split.length) {
    result.push(getValue(split.slice(i - 1, i + 4)));
    i += 4;
  }
  return result;
};

const getParsedValue: (value: string | undefined) => IValue[] = (value) => {
  const result = getParsedPql(value);
  return result;
};

const getFirstValue: (value: string[]) => IValue = ([key, operator, value, config]) => {
  config = config || 'AND';
  return { key, operator, value, config };
};

const getValue: (value: string[]) => IValue = ([config, key, operator, value]) => {
  config = config || '';
  return { key, operator, value, config };
};

const getParsePql = (value?: string): string[] => {
  const split: string[] = [];
  let acc = '';
  let isValue = false;
  for (const str of clearPql(value)) {
    if (str === ']') isValue = false;
    if (isValue) {
      acc += str;
      continue;
    }
    if (str === '[') {
      isValue = true;
      acc += str;
      continue;
    }
    if (str === ' ') {
      split.push(acc);
      acc = '';
      continue;
    }
    acc += str;
  }
  split.push(acc);
  const upperCaseOperator = (item: string, i: number): string => (!((i + 1) % 2) ? item.toUpperCase() : item);
  return split.map(upperCaseOperator);
};

const clearPql = (value?: string): string =>
  (value || '')
    .replace(/"|'/g, `'`)
    .replace(/\s+/g, ' ')
    .replace(/\s,\s|,\s|\s,/g, ',')
    .replace(/\[\s/g, '[')
    .replace(/\s]/g, ']')
    .trim();

export { getParsedValue, getStringValue, mentionSelect, mentionConfig, clearPql };
